import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    paddingTop: 24
  },
  height10:{
    height: 10
  }
}));